import "./PatientCard.css"

function PatientCard(props) {
    return (
        <div className="all-table-items">
            <tr className="item-table">
                <td className="item">{props.patient.name}</td>
                <td className="item">{props.patient.age}</td>
                <td className="item">{props.patient.sex}</td>
                <td className="item">{props.patient.phone}</td>
                <td className="item"><button className="btn btn-success">Details</button></td>
            </tr>
        </div >
    );
}

export default PatientCard;